import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Sheet } from 'react-modal-sheet'
import BottomSheet from '~components/ui/bottom-sheet'
import Icon from '~components/ui/icon'
import Label from '~components/ui/label'
import { getMatchRateColor } from '~containers/app/consultation-detail/utils'
import Loading from '~containers/general/loading'
import { ConsultationContent } from '../converation-content'
import ErrorFallback from '~containers/general/error'

type Props = Readonly<{
  open: boolean
  id: number
  matchRate: number
  onClose: () => void
}>

const Header = ({ matchRate, onClose }: Pick<Props, 'matchRate' | 'onClose'>) => {
  return (
    <div className="flex items-center justify-between">
      <Label color={getMatchRateColor(matchRate)}>{matchRate}% Match</Label>
      <button
        type="button"
        onClick={onClose}
        aria-label="close-button"
        className="p-2 bg-transparent"
      >
        <Icon name="close" className="size-6 fill-gray-500" />
      </button>
    </div>
  )
}

const SmartSearchBottomSheet = ({ open, id, matchRate, onClose }: Props) => {
  return (
    <BottomSheet isOpen={open} onCloseRequest={onClose} detent="full-height">
      <div className="pt-3 pl-5 pr-3 pb-2">
        <Header matchRate={matchRate} onClose={onClose} />
      </div>
      <Sheet.Scroller>
        <QueryErrorResetBoundary>
          {({ reset }) => (
            <ErrorBoundary onReset={reset} FallbackComponent={ErrorFallback}>
              <Suspense fallback={<Loading />}>
                <ConsultationContent consultationId={id} />
              </Suspense>
            </ErrorBoundary>
          )}
        </QueryErrorResetBoundary>
      </Sheet.Scroller>
    </BottomSheet>
  )
}

export default SmartSearchBottomSheet
